import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '../../../insa-services';

@Component({
  selector: 'registration-form',
  templateUrl: 'registration-form.component.html',
})
export class RegistrationFormComponent {
  @Input() registrationForm;
  @Output() formSubmit = new EventEmitter();
  @Output() registrationStateChange = new EventEmitter<{
    isSuccess?: boolean;
    isError?: boolean;
  }>();

  constructor(private _authService: AuthService) {
    _authService.registrationSuccessEmitter.subscribe((isSuccess) => {
      if (isSuccess) {
        this.registrationStateChange.emit({ isSuccess: true });
      } else {
        this.registrationStateChange.emit({ isError: true });
        this.showErrorModal();
      }
    });
  }

  showErrorModal() {
    $('#registrationErrorModal').modal('show');
  }

  submitRegistration(): void {
    this.formSubmit.emit();
  }

  private get username() {
    return this.registrationForm.get('username');
  }
  private get email() {
    return this.registrationForm.get('email');
  }
  private get password() {
    return this.registrationForm.get('password');
  }
  private get confirmPassword() {
    return this.registrationForm.get('confirmPassword');
  }
  private get fullName() {
    return this.registrationForm.get('fullName');
  }
  private get street() {
    return this.registrationForm.get('street');
  }
  private get number() {
    return this.registrationForm.get('number');
  }
  private get city() {
    return this.registrationForm.get('city');
  }
  private get country() {
    return this.registrationForm.get('country');
  }
  private get phone() {
    return this.registrationForm.get('phone');
  }
  private get fax() {
    return this.registrationForm.get('fax');
  }
  private get mobile() {
    return this.registrationForm.get('mobile');
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/registration/registration-form.component.ts